import axios from 'index/axios'
import Vue from 'vue'
const loading = 'loading'

const cache = {}

/**
 * 获取token
 */
export const getToken = () => {
  if (cache.token) return cache.token
  cache.token = axios.get('/', {}, { responseType: 'text' }).then(({ data }) => {
    delete cache.token
    let token = Vue.ls.get('ACCESS_TOKEN')
    if (token !== undefined && token !== null && token !== '') return token
    return ''
  }).catch(() => {
    delete cache.token
  })
  return cache.token
}

/**
 * 登录
 */
export const signIn = data => axios.post('/jkd/home/login', data, { loading, silent: true }).then(({ data }) => data)

/**
 * 登出
 */
export const signOut = data => axios.get('/jkd/home/logout', data)

/**
 * 获取用户信息
 */
export const getUserInfo = (data) => {
  if (cache.userinfo) return cache.userinfo
  cache.userinfo = axios.post('/jkd/home/user', data, { timeout: 60 * 1000 }).then(({ data }) => data.data).finally(() => {
    delete cache.userinfo
  })
  return cache.userinfo
}

export * from './xunjian'

/**
 * 修改密码
 * @typedef {object} Param
 * @property {string} oldpwd
 * @property {string} newpwd
 * @property {string} confirmpwd
 * @param {Param} data
 */
export const changePassword = data => axios.post('/admin/user/save/password', data, { loading: 'submit' }).then(({ data = {} }) => data.message || '操作成功')

export const updateExpireTime = () => axios.get('pc/expireTime')

